import { useRef, useState } from "react";
import axios from "axios";
import { logError } from "utils/logger";
import fetchRecaptchaToken from "services/google/fetchRecaptchaTokenService";
import { customerDetailsFormFields } from ".";

const useFormSubmission = () => {
    const isFormSubmissionSuccessful = useRef<boolean>(false);
    const [recaptchaToken, setRecaptchaToken] = useState("");

    const handleFormSubmission = async (
        formData: customerDetailsFormFields,
        emailTemplateName?: string
    ) => {
        try {
            const recaptchaTokenResponse = await fetchRecaptchaToken();
            if (!recaptchaTokenResponse.success) {
                throw new Error("Failed to fetch recaptcha token");
            }

            const token = recaptchaTokenResponse.token;

            const recaptchaVerificationResponse = await axios.post("/api/recaptcha", { token });
            if (
                recaptchaVerificationResponse.status !== 200 ||
                !recaptchaVerificationResponse.data.success
            ) {
                isFormSubmissionSuccessful.current = false;
                throw new Error("Failed to verify recaptcha token");
            }
            if (!!token) {
                setRecaptchaToken(token);
            }

            const customerResponse = await axios.post("/api/customer", formData);
            if (customerResponse.status !== 200) {
                isFormSubmissionSuccessful.current = false;
                throw new Error("Failed to save customer record");
            }

            if (emailTemplateName) {
                const emailResponse = await axios.post("/api/email", {
                    email: formData.email,
                    emailTemplateName: emailTemplateName,
                    additionalVariables: {
                        FirstName: formData.firstName,
                        LastName: formData.lastName,
                        ContactNumber: formData.contactNumber,
                        Postcode: formData.postCode,
                    },
                });
                if (emailResponse.status !== 200) {
                    isFormSubmissionSuccessful.current = false;
                    throw new Error("Failed to send email");
                }
            }
            isFormSubmissionSuccessful.current = true;
        } catch (error) {
            isFormSubmissionSuccessful.current = false;
            const errorMessage = (error as Error).message;
            logError("Error occured submitting the form", errorMessage);
        }
    };

    return {
        isFormSubmissionSuccessful,
        handleFormSubmission,
        recaptchaToken,
    };
};

export default useFormSubmission;
